import React from "react";
import styles from "./styles.module.less";
import { usePerfil } from "./usePerfil";
import { isLocalhost } from "../../apis/backend/Api";
import { Alert } from "antd";
import { LazySuspense } from "../../components/layout/AppHeader/lazySuspense";
import { selectStoreUsuarioActivo } from "../../redux/helpers/selectStore";
const AppHeader = React.lazy(
  () => import("../../components/layout/AppHeader/appHeader"),
);
const AppFooter = React.lazy(
  () => import("../../components/layout/AppFooter/AppFooter"),
);
export const ProtectedRoleAccountManager = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const objUsuarioStore = selectStoreUsuarioActivo();
  let perfil = usePerfil("3");

  if (isLocalhost) return children;
  if (objUsuarioStore.IdPerfil === "7") {
    return children;
  }
  if (!perfil.isPerfil) {
    return NotAuthorized();
  } else {
    return children;
  }
};
function NotAuthorized() {
  return (
    <>
      <div>
        <LazySuspense>
          <AppHeader />
        </LazySuspense>
        <div className={styles.contentStyle}>
          <Alert message={"Usuario no autorizado"} type={"warning"} />
        </div>
      </div>

      <LazySuspense>
        <AppFooter />
      </LazySuspense>
    </>
  );
}
